<template>
  <div class="about-us awards" id="awards">
    <header class="page-header" data-aos="fade-up">
      <div class="video-container">
        <video class="header-video" src="static/img/about-us/falcon.mp4" autoplay loop></video>
      </div>
      <div class="container">
        <div v-html="$t('awards.hedingTopText')" class="heading-text" data-aos="fade-up">
        </div>
      </div>
      <a @click="smoothScroll" href="#top" :data-scroll-offset="scrollOffset" class="more-about-us white"
         data-aos="fade-up"><span>{{$t('awards.seeAwards')}}</span></a>
    </header>
    <div class="product">
      <div class="why-us-solution" id="top">
        <div class="elements">

          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                 <span class="text" data-aos="fade-up" v-if="lang === 'pl'">Uniejów, 06.2025 Lider Inteligentnego Rozwoju</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Leader of Intelligent Development</span> 
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  W czerwcu 2025 roku podczas gali w Uniejowie zostaliśmy uhonorowani nagrodą „Lider Inteligentnego Rozwoju”. To wyróżnienie potwierdza naszą determinację w dążeniu do innowacji oraz rozwój oparty na nowoczesnych technologiach.

                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  Bioseco was honored with the “Leader of Intelligent Development” award. This recognition confirms our commitment to innovation and growth driven by cutting-edge technologies.
                </p>
              </div>
            </div>
            <div>
              <img style="max-width: 200px;" src="/static/img/awards/Leader_of_Intelligent_Development.png"/>
            </div>
          </div>

          <div class="element clearfix">
              <div>
              <img src="/static/img/awards/Polish-German_Economic_Award.png"/>
            </div>
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                   <span class="text" data-aos="fade-up" v-if="lang === 'pl'">2024 Polsko–Niemiecka Nagroda Gospodarcza</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Polish-German Economic Award</span>  
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                 Bioseco otrzymało Polsko–Niemiecką Nagrodę Gospodarczą, która podkreśla nasze zasługi w budowaniu partnerskich relacji biznesowych między Polską a Niemcami. To wyróżnienie stanowi dowód na naszą skuteczność i zaangażowanie w rozwój współpracy międzynarodowej.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
Bioseco received the Polish-German Economic Award, which highlights our contributions to building strong business partnerships between Poland and Germany. This recognition serves as proof of our effectiveness and commitment to fostering international cooperation.                </p>
              </div>
            </div>
          
          </div>

          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                     <span class="text" data-aos="fade-up" v-if="lang === 'pl'">2023 Nagroda Pomorska Gryf Gospodarczy</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Pomeranian Economic Griffin Award</span>  
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
Zostaliśmy uhonorowani Nagrodą Pomorski Gryf Gospodarczy, która docenia nasz wkład w rozwój regionalnej gospodarki. To prestiżowe wyróżnienie podkreśla nasze zaangażowanie i sukcesy na Pomorzu.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
We were honored with the Pomeranian Economic Griffin Award, recognizing our contribution to the development of the regional economy. This prestigious distinction highlights our commitment and achievements in the Pomerania region.                </p>
              </div>
            </div>
            <div>
              <img style="margin-left: 10px;" src="/static/img/awards/Pomeranian_Economic_Griffin_Award.png"/>
            </div>
          </div>

          <div class="element clearfix">
              <div>
              <img src="/static/img/awards/Eagle_of_Innovation.png"/>
            </div>
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                        <span class="text" data-aos="fade-up" v-if="lang === 'pl'">2022 Orzeł Innowacji „Rzeczpospolitej”</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Eagle of Innovation</span>  
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
Otrzymaliśmy prestiżową nagrodę Orzeł Innowacji „Rzeczpospolitej”, która wyróżnia naszą innowacyjność i nowatorskie rozwiązania. To potwierdzenie naszego zaangażowania w rozwój technologiczny i ciągłe poszukiwanie innowacji.                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
Bioseco received the prestigious “Rzeczpospolita” Eagle of Innovation Award, which recognizes our innovation and pioneering solutions. This accolade confirms our dedication to technological development and continuous pursuit of innovation.    </p>          </div>
            </div>
          
          </div>

          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
        <span class="text" data-aos="fade-up" v-if="lang === 'pl'">2021 Polski Produkt Przyszłości</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Polish Product of the Future</span>                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
zdobyliśmy wyróżnienie Polski Produkt Przyszłości, które podkreśla innowacyjny charakter naszego rozwiązania. To potwierdzenie naszej wizji i zaangażowania w tworzenie nowoczesnych technologii.               </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
We were awarded the Polish Product of the Future distinction, which highlights the innovative nature of our solution. This recognition confirms our vision and commitment to developing modern technologies.    </p>          </div>
            </div>
            <div>
              <img src="/static/img/awards/Polish_Product_of_the_Future.png"/>
            </div>
          </div>

          <div class="element clearfix">
            <div>
              <img src="/static/img/awards/Rzeczpospolita_Green_Eagle.png"/>
            </div>
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                    <span class="text" data-aos="fade-up" v-if="lang === 'pl'">2021 Zielony Orzeł "Rzeczpospolitej"</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">“Rzeczpospolita” Green Eagle</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
Otrzymaliśmy Zielonego Orła „Rzeczpospolitej”, nagrodę za nasze działania na rzecz zrównoważonego rozwoju i ekologii. To wyróżnienie podkreśla nasze zaangażowanie w ochronę środowiska i odpowiedzialność społeczną.              </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">

Bioseco received the “Rzeczpospolita” Green Eagle Award for our efforts in sustainable development and environmental protection. This recognition highlights our commitment to environmental stewardship and social responsibility.    </p>          </div>
            </div>
            
          </div>

          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up">Tech Tour Photonics</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Genewa-Bruksela, 10.2020.</em>
                  Bioseco znalazła się w gronie zwycięzców programu Tech Tour Photonics.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Geneva-Brussels, 10.2020.</em>
                  Bioseco was among the winners of the Tech Tour Photonics program.
                </p>
              </div>
            </div>
            <div>
              <img src="/static/img/media/photonics.jpg"/>
            </div>
          </div>

          <div class="element clearfix">
            <div  class="hide-mobile">
              <img src="/static/img/media/top50.jpg"/>
            </div>
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up" v-if="lang === 'pl'">50 Najbardziej Kreatywnych</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">50 Most Creative People in Business</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Warszawa, 28.09.2020.</em>
                  II Miejsce wśród 50 Najbardziej Kreatywnych Ludzi w Biznesie dla Krzysztofa Paszka, współzałożyciela
                  Bioseco. Nagroda zdobyta na dziesiątej Jubileuszowej Gali pod patronatem Ministerstwa Rozwoju, PKN
                  Orlen SA, Google for Startups, Santander Bank Polska, Krajowa Izba Gospodarcza.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Warsaw, September 28, 2020.</em>2nd place among the 50 Most Creative People in Business for Krzysztof
                  Paszek, co-founder of Bioseco. The award was won at the tenth Jubilee Gala under the patronage of the
                  Polish Ministry of Development, PKN Orlen SA, Google for Startups, Santander Bank Polska, the Polish
                  Chamber of Commerce.
                </p>
              </div>
            </div>
            <div  class="show-mobile">
              <img src="/static/img/media/top50.jpg"/>
            </div>
          </div>


          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up" v-if="lang === 'pl'">Miesięcznik „My Company”</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Monthly newspaper "My Company"</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Warszawa, 08.2019</em>
                  Bioseco w gronie dwudziestu firm, które zmienią Polskę według miesięcznika „My Company”.
                </p>

                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Warsaw, 08.2019.</em>
                  Bioseco among twenty companies that will change Poland according to the monthly newspaper "My
                  Company".
                </p>
              </div>
            </div>
            <div>
<!--                            <img src="/static/img/media/photonics.jpg" />-->
            </div>
          </div>

          <div class="element clearfix">
            <div  class="hide-mobile">
              <img src="/static/img/media/pozytywny.jpg"/>
            </div>
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up" v-if="lang === 'pl'">Bioseco startupem pozytywnego wpływu</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Bioseco - Positive Impact Startup</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Warszawa, 04.2019.</em>
                  Bioseco startupem pozytywnego wpływu. W pierwszej edycji Raportu Startupów Pozytywnego Wpływu 2019
                  organizowanego przez Kozminski Business Hub wśród innowacyjnych polskich startupów znalazło się
                  Bioseco.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Warsaw, 04.2019.</em>
                  Bioseco - Positive Impact Startup. In the first edition of the 2019 Positive
                  Impact Startup Report organized by Kozminski Business Hub, Bioseco was among the innovative Polish
                  startups.</p>
              </div>
            </div>
            <div  class="show-mobile">
              <img src="/static/img/media/pozytywny.jpg"/>
            </div>
          </div>

          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up">2018 IEEE N3XT® STAR.</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Parlament Europejski. Bruksela, 2019.</em>
                  Bioseco znalazło się w gronie firm z obszaru innowacyjnych technologii wybranych przez jury IEEE
                  Entrepreneurship Stars, organizacji pod patronatem Parlamentu Europejskiego.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Brussels, 2019.</em>
                  2018 IEEE N3XT® STAR. Bioseco is among the companies in the area of ​​innovative
                  technologies selected by the jury of IEEE Entrepreneurship Stars, an organization under the patronage
                  of the European Parliament.
                </p>
              </div>
            </div>
            <div>
              <img src="/static/img/media/iee_resized.jpg"/>
            </div>
          </div>

          <div class="element clearfix">
            <div  class="hide-mobile">
              <img src="/static/img/media/eu50_resized.jpg"/>
            </div>
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up">EUtop50</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Bruksela, 29.11.2018.</em>
                  Wygrana w prestiżowym konkursie EUtop50 dla innowatorów z całej Unii Europejskiej. Dziesiąta edycja
                  konkursu organizowanego przez Parlament Europejski.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Brussels, 29/11/2018.</em>
                  Winner of the prestigious EUtop50 Innovators, contest for young companies
                  from all over the European Union. The tenth edition of the competition organized by the European
                  Parliament.
                </p>
              </div>
            </div>
            <div  class="show-mobile">
              <img src="/static/img/media/eu50_resized.jpg"/>
            </div>
          </div>


          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up">“Pomorskie Sztormy”</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Gdańsk, 08.04.2015.</em>
                  Pomorskie Sztormy, Zwycięzca konkursu w kategorii Młoda Firma Roku 2014. 10 edycja plebiscytu Gazety
                  Wyborczej i Marszałka Województwa Pomorskiego.
                </p>

                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Gdańsk, April 8, 2015.</em>
                  “Pomorskie Sztormy”, Winner of the competition in the Young Company of the
                  Year 2014 category. 10th edition of the Gazeta Wyborcza and the Marshal of the Pomeranian Voivodeship.
                </p>


              </div>
            </div>
            <div>
              <img src="/static/img/media/sztormy.jpg"/>
            </div>
          </div>


          <div class="element clearfix">
            <div  class="hide-mobile">
              <img src="/static/img/media/lider-ppnt.jpg"/>
            </div>
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up" v-if="lang === 'pl'">Lider PPNT</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Leader of the PPNT</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Gdynia 12.2014.</em>
                  Lider Pomorskiego Parku Naukowo-Technologicznego w Gdyni. Nagroda przyznana przez społeczność prawie
                  trzystu firm z obszaru nowych technologii.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Gdynia 12.2014.</em>
                  Leader of the Pomeranian Science and Technology Park in Gdynia. The award was
                  granted by a community of three hundred innovative companies.
                </p>
              </div>
            </div>
            <div  class="show-mobile">
              <img src="/static/img/media/lider-ppnt.jpg"/>
            </div>
          </div>


          <div class="element clearfix">
            <div>
              <div class="text-box">
                <div class="heading">
                  <div class="hexagon" data-aos="flip-right" data-aos-delay="100"></div>
                  <span class="text" data-aos="fade-up" v-if="lang === 'pl'">Nagroda Grand Prix Innowacje 2014</span>
                  <span class="text" data-aos="fade-up" v-if="lang !== 'pl'">Grand Prix Innovation 2014 award</span>
                </div>
                <p class="text" data-aos="fade-up" v-if="lang === 'pl'">
                  <em>Gdańsk, 24.10.2014.</em>
                  Nagroda Grand Prix Innowacje 2014. Technikon, 10 Targi Techniki Przemysłowej Nauki i Innowacji.
                </p>
                <p class="text" data-aos="fade-up" v-if="lang !== 'pl'">
                  <em>Gdańsk, October 24, 2014.</em>
                  Grand Prix Innovation 2014 award. Technikon, 10th Industrial Technology,
                  Science and Innovation Fairs.
                </p>
              </div>
            </div>
            <div>
              <img src="/static/img/media/grandprix.jpg"/>
            </div>
          </div>


        </div>
      </div>
    </div>
    <footer-main/>
  </div>
</template>

<script>
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import MediaBox from '../components/MediaBox';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'awards',
    data() {
      return {
        popupActivo: false,
        popupActivo2: false,
      }
    },
    props: [],
    methods: {},
    components: {
      FooterMain,
      FooterMoreInformation,
      MediaBox
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      scrollOffset: () => {
        return window.innerWidth > 980 ? 130 : 90;
      },
      smoothScroll: () => smoothScroll
    }
  }
</script>

<style scoped="">
  .show-mobile{
    display: none;
  }

  .about-us.awards .heading {
    margin-top: 10px;
  }

  .awards header.page-header {
    min-height: 320px;
  }

  .awards .product .why-us-solution .elements .element {
    display: flex;
    flex-direction: row;
    margin-bottom: 50px;
  }

  .awards .product .why-us-solution .elements .element .text-box .heading .text {
    font-size: 18px;
    margin-left: 10px;
    max-width: 240px;
    line-height: 22px;
  }
  .awards .product .why-us-solution .elements .element .text-box  em{
    display: block;
    font-size: 18px;
    line-height: 1.6em;
    color: #f2b667;
  }

  .awards .product .why-us-solution .elements .element .text-box {
    margin-top: 10px;
  }

  .awards .product .why-us-solution .elements .element .text-box p {
    margin: 20px 0;
    padding: 0 20px;
  }

  .awards .product .why-us-solution .elements .element img {
    max-width: 400px;
  }

  @media (max-width: 980px) {
    .product .why-us-solution .elements .element .text-box .heading .hexagon{
      display: none;
    }
    .product .why-us-solution .elements .element .text-box .heading{
      width: 90%;
    }
  }
  @media (max-width: 780px) {
    .awards .product .why-us-solution .elements .element{
      flex-direction: column;
    }
    .show-mobile{
      display: block;
    }
    .hide-mobile{
      display: none;
    }
    .product .why-us-solution .elements .element .text-box .heading{
      width: 100%;
    }
    .product .why-us-solution .elements .element .text-box .heading .text{
      text-align: left;
      width: 100%;
    }
    .awards .product .why-us-solution .elements .element img{
      width: 100%;
    }
  }

</style>




// WEBPACK FOOTER //
// Awards.vue?5e814746